
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const nav = document.getElementById('nav');
const burger = document.getElementById('burger');
if (nav && burger) burger.addEventListener('click', () => {
  const open = nav.classList.toggle('menu-open');
  burger.setAttribute('aria-expanded', open);
  if (open) nav.classList.add('scrolled');
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && nav && nav.classList.contains('menu-open')) {
    nav.classList.remove('menu-open'); burger.setAttribute('aria-expanded', 'false');
  }
});
if (nav) nav.querySelectorAll('.nav-drawer a').forEach(a => a.addEventListener('click', () => {
  nav.classList.remove('menu-open');
  burger.setAttribute('aria-expanded', 'false');
}));
const hero = document.getElementById('hero');
const bar = document.querySelector('.bar');
if (nav) {
  const onScrollNav = () => {
    const bh = bar ? bar.offsetHeight : 0;
    nav.style.top = Math.max(0, bh - scrollY) + 'px';
    const solid = hero ? scrollY > hero.offsetHeight - 90 : true;
    nav.classList.toggle('scrolled', solid || nav.classList.contains('menu-open'));
  };
  onScrollNav();
  addEventListener('scroll', onScrollNav, {passive:true});
  addEventListener('resize', onScrollNav);
  addEventListener('load', onScrollNav);
}
if (hero) {
  requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('loaded')));
  const heroMedia = document.getElementById('heroMedia');
  if (heroMedia && !reduced) {
    let t = false;
    addEventListener('scroll', () => { if (t) return; t = true;
      requestAnimationFrame(() => { heroMedia.style.transform = `translateY(${Math.min(scrollY, innerHeight) * 0.14}px)`; t = false; });
    }, {passive:true});
  }
}
const io = new IntersectionObserver(entries => {
  for (const e of entries) { if (!e.isIntersecting) continue;
    const el = e.target;
    const sib = [...el.parentElement.querySelectorAll(':scope > .reveal, :scope > * > .reveal')];
    el.style.transitionDelay = Math.min(Math.max(0, sib.indexOf(el)) * 70, 280) + 'ms';
    el.classList.add('in'); io.unobserve(el);
  }
}, {rootMargin:'0px 0px -8% 0px', threshold:0.1});
document.querySelectorAll('.reveal').forEach(el => io.observe(el));
const ioBleed = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); ioBleed.unobserve(e.target); } }), {threshold:0.25});
document.querySelectorAll('.bleed').forEach(el => ioBleed.observe(el));
const st = document.getElementById('statementText');
if (st) {
  const words = st.innerHTML.trim().split(/\s+(?![^<]*>)/);
  st.innerHTML = words.map(w => `<span class="w">${w}</span>`).join(' ');
  const ws = [...st.querySelectorAll('.w')];
  if (!reduced) {
    let k = false;
    const lit = () => { const r = st.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (innerHeight * 0.78 - r.top) / (r.height + innerHeight * 0.3)));
      const n = Math.round(p * ws.length); ws.forEach((w,i) => w.classList.toggle('lit', i < n)); };
    addEventListener('scroll', () => { if (k) return; k = true; requestAnimationFrame(() => { lit(); k = false; }); }, {passive:true});
    lit();
  } else ws.forEach(w => w.classList.add('lit'));
}
const trail = document.getElementById('trail');
if (trail) {
  const ioT = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { trail.classList.add('go'); ioT.disconnect(); } }), {threshold:0.5});
  ioT.observe(trail);
}

// Scrolldrivna marquees — ett rAF-loop för alla band
(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var tracks = Array.prototype.slice.call(document.querySelectorAll('.marquee-scrub .marquee-track'));
  if (!tracks.length) return;
  var state = tracks.map(function(t){ return {el: t, off: 0, half: t.scrollWidth / 2}; });
  addEventListener('resize', function(){ state.forEach(function(s){ s.half = s.el.scrollWidth / 2; }); });
  var vel = 0, lastY = window.scrollY;
  addEventListener('scroll', function(){
    vel += Math.abs(window.scrollY - lastY) * 0.06;
    lastY = window.scrollY;
  }, {passive: true});
  (function loop(){
    var step = 0.9 + Math.min(vel, 6);
    vel *= 0.9;
    state.forEach(function(s){
      s.off += step;
      if (s.half > 0 && s.off >= s.half) s.off -= s.half;
      s.el.style.transform = 'translate3d(-' + s.off.toFixed(1) + 'px,0,0)';
    });
    requestAnimationFrame(loop);
  })();
})();

// Läk bilder som fastnat — både felade och evigt pendlande (lazy-bilder gör inga omförsök själva)
function healStuckImages(){
  document.querySelectorAll('img').forEach(function(im){
    if (im.dataset.healed || !im.src) return;
    var broken = im.complete && im.naturalWidth === 0;
    var pending = !im.complete;
    if (broken || pending) {
      im.dataset.healed = '1';
      var s = im.src;
      im.removeAttribute('loading');
      im.src = '';
      im.src = s;
    }
  });
}
addEventListener('load', function(){ setTimeout(healStuckImages, 1200); setTimeout(healStuckImages, 5000); });
setTimeout(healStuckImages, 7000);
